var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_ID,
            title: "Translate Image",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            "modal-class": "translate-template-image-modal",
            "header-class": "draggable-modal-header border-0",
            "body-class": "py-0",
          },
          on: {
            show: _vm.onModalOpen,
            shown: _vm.onModalShown,
            hide: _vm.onModalHide,
            hidden: _vm.onModalHidden,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center w-100" },
                    [
                      _c(
                        "h5",
                        {
                          staticClass: "modal-title mb-0 text-lg font-semibold",
                        },
                        [_vm._v("\n          Translate Image\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ml-auto d-flex align-items-center" },
                        [
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "translate-advanced-dropdown",
                              attrs: {
                                right: "",
                                "no-caret": "",
                                variant: "transparent",
                                "toggle-class":
                                  "btn-sm translate-settings-gear",
                                "menu-class": "translate-advanced-menu",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName:
                                                "v-b-tooltip.hover.viewport.noninteractive",
                                              modifiers: {
                                                hover: true,
                                                viewport: true,
                                                noninteractive: true,
                                              },
                                            },
                                          ],
                                          staticClass: "bi bi-gear",
                                          attrs: { title: "Advanced" },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "translate-advanced-menu__title",
                                },
                                [
                                  _vm._v(
                                    "\n              Advanced\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group mb-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-medium text-sm",
                                    attrs: { for: "modelSelect" },
                                  },
                                  [_vm._v("Select Model")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedModel,
                                        expression: "selectedModel",
                                      },
                                    ],
                                    staticClass: "form-control custom-select",
                                    attrs: { id: "modelSelect" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedModel = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(_vm.modelOptions, function (opt) {
                                    return _c(
                                      "option",
                                      {
                                        key: opt.value,
                                        domProps: { value: opt.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(opt.text) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox mt-2",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.upscaleTranslatedImage,
                                          expression: "upscaleTranslatedImage",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "upscaleTranslatedImageCheckbox",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.upscaleTranslatedImage
                                        )
                                          ? _vm._i(
                                              _vm.upscaleTranslatedImage,
                                              null
                                            ) > -1
                                          : _vm.upscaleTranslatedImage,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.upscaleTranslatedImage,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.upscaleTranslatedImage =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.upscaleTranslatedImage =
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.upscaleTranslatedImage = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "upscaleTranslatedImageCheckbox",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Allow the translated image to be upscaled\n                  "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "upscale-image-tooltip",
                                            attrs: { role: "tooltip" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Caution: Upscaling may inaccurately reconstruct or invent small text that is unreadable in the original image.\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button", "aria-label": "Close" },
                              on: { click: close },
                            },
                            [_c("i", { staticClass: "bi bi-x" })]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "position-relative modal-content-wrapper" },
            [
              !_vm.showTranslationSettings
                ? _c("div", [
                    _vm.isLoading
                      ? _c("div", { staticClass: "translate-running-banner" }, [
                          _c("i", {
                            staticClass:
                              "bi bi-info-circle-fill translate-running-banner__icon",
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "You can close this window. Translation will continue and we’ll notify you when it’s done."
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "font-medium text-sm",
                            attrs: { for: "backgroundImageSelect" },
                          },
                          [_vm._v("Select Image")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "image-select-dropdown",
                            attrs: {
                              id: "backgroundImageSelect",
                              text: _vm.selectedImageText,
                              block: "",
                              "menu-class": "w-100 image-dropdown-menu",
                              variant: "outline-secondary",
                            },
                          },
                          _vm._l(_vm.backgroundImages, function (option) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: option.value,
                                attrs: {
                                  active:
                                    _vm.selectedBackgroundImageIndex ===
                                    option.value,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedBackgroundImageIndex =
                                      option.value
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    option.thumbnail
                                      ? _c("img", {
                                          staticClass: "image-thumbnail mr-2",
                                          attrs: {
                                            src: option.thumbnail,
                                            alt: "",
                                          },
                                        })
                                      : _c("span", {
                                          staticClass:
                                            "image-thumbnail-placeholder mr-2",
                                        }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(option.text))]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedImage
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-medium text-sm" },
                                  [
                                    _vm._v(
                                      "\n              Select Text Blocks to Translate\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 clear-selection-button",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.isLoadingTextBlocks ||
                                        !_vm.hasSelectedTextBlocks,
                                    },
                                    on: { click: _vm.clearSelectedTextBlocks },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("Multiselect", {
                                  attrs: {
                                    options: _vm.isLoadingTextBlocks
                                      ? []
                                      : _vm.detectedTextBlocks,
                                    multiple: true,
                                    "close-on-select": false,
                                    "clear-on-select": false,
                                    placeholder: _vm.isLoadingTextBlocks
                                      ? "Loading..."
                                      : "Select text blocks",
                                    disabled: _vm.isLoadingTextBlocks,
                                  },
                                  on: {
                                    input: function ($event) {
                                      _vm.showTextBlocksError = false
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function ({ option }) {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(option)),
                                            ]),
                                            _vm._v(" "),
                                            _vm.isProductImageTextBlock(option)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-block-product-badge",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Product image\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2431110075
                                  ),
                                  model: {
                                    value: _vm.selectedTextBlocks,
                                    callback: function ($$v) {
                                      _vm.selectedTextBlocks = $$v
                                    },
                                    expression: "selectedTextBlocks",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.showTextBlocksError
                                  ? _c(
                                      "div",
                                      { staticClass: "text-danger small mt-1" },
                                      [
                                        _vm._v(
                                          "\n              Please select at least one text block to translate.\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox mt-2",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.detectBrandText,
                                          expression: "detectBrandText",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "detectBrandTextCheckbox",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.detectBrandText
                                        )
                                          ? _vm._i(_vm.detectBrandText, null) >
                                            -1
                                          : _vm.detectBrandText,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.detectBrandText,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.detectBrandText =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.detectBrandText = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.detectBrandText = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "detectBrandTextCheckbox",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Include logos, brand names, and product names\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between align-items-center",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "font-medium text-sm",
                                        attrs: { for: "targetLanguageSelect" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Select Languages\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center language-actions",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-link p-0 clear-selection-button glossary-settings-button",
                                            attrs: { type: "button" },
                                            on: {
                                              click:
                                                _vm.openTranslationSettings,
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "glossary-settings-button__icon",
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "14",
                                                  height: "14",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: { d: "m8 13 4-7 4 7" },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: { d: "M9.1 11h5.7" },
                                                }),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                  Glossary & excluded terms\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-link p-0 clear-selection-button",
                                            attrs: {
                                              type: "button",
                                              disabled: !_vm.canTranslate,
                                            },
                                            on: {
                                              click:
                                                _vm.clearSelectedTargetLanguages,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Clear\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("Multiselect", {
                                  staticClass: "multiselect-language",
                                  attrs: {
                                    id: "targetLanguageSelect",
                                    options: _vm.availableLanguages,
                                    multiple: true,
                                    "close-on-select": false,
                                    taggable: false,
                                    placeholder: "Select language(s)...",
                                  },
                                  model: {
                                    value: _vm.selectedTargetLanguages,
                                    callback: function ($$v) {
                                      _vm.selectedTargetLanguages = $$v
                                    },
                                    expression: "selectedTargetLanguages",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-alert",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  variant: "warning",
                                  dismissible: "",
                                  show: _vm.showAlreadyGeneratedWarning,
                                },
                                on: {
                                  dismissed: function ($event) {
                                    _vm.showAlreadyGeneratedWarning = false
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            All selected languages have already been generated.\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectedImage
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      "translated-images-grid":
                                        _vm.translatedImageUrls.length > 0,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "translated-image-item" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "image-preview-wrapper position-relative",
                                          },
                                          [
                                            _vm.editedImageUrl ||
                                            _vm.translatedImageUrls.length > 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "translated-image-label text-xs text-muted-foreground",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Original\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("img", {
                                              staticClass:
                                                "img img-fluid modal-preview-image",
                                              attrs: { src: _vm.selectedImage },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "image-actions-container",
                                                style:
                                                  _vm.editedImageUrl ||
                                                  _vm.translatedImageUrls
                                                    .length > 0
                                                    ? { top: "35px" }
                                                    : { top: "10px" },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "download-btn",
                                                    attrs: {
                                                      title: "Download image",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.toggleOriginalDownloadOptions.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "bi bi-download",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.activeOriginalDownloadOptions
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-download-dropdown",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center mb-3",
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "custom-radio mr-3 mb-0",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .downloadOptions
                                                                          .format,
                                                                      expression:
                                                                        "downloadOptions.format",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "radio",
                                                                    value:
                                                                      "jpg",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      _vm._q(
                                                                        _vm
                                                                          .downloadOptions
                                                                          .format,
                                                                        "jpg"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.downloadOptions,
                                                                          "format",
                                                                          "jpg"
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span"),
                                                                _vm._v(
                                                                  " JPG\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "custom-radio mb-0",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .downloadOptions
                                                                          .format,
                                                                      expression:
                                                                        "downloadOptions.format",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "radio",
                                                                    value:
                                                                      "png",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      _vm._q(
                                                                        _vm
                                                                          .downloadOptions
                                                                          .format,
                                                                        "png"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.downloadOptions,
                                                                          "format",
                                                                          "png"
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span"),
                                                                _vm._v(
                                                                  " PNG\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.downloadOptions
                                                          .format === "jpg"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center mb-3",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "download-label mb-0 mr-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Max size"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model.number",
                                                                      value:
                                                                        _vm
                                                                          .downloadOptions
                                                                          .maxSize,
                                                                      expression:
                                                                        "downloadOptions.maxSize",
                                                                      modifiers:
                                                                        {
                                                                          number: true,
                                                                        },
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form-control form-control-sm download-size-input",
                                                                  attrs: {
                                                                    type: "number",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .downloadOptions
                                                                        .maxSize,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm.downloadOptions,
                                                                          "maxSize",
                                                                          _vm._n(
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        )
                                                                      },
                                                                    blur: function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$forceUpdate()
                                                                    },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "download-unit ml-2",
                                                                  },
                                                                  [_vm._v("KB")]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary w-100",
                                                            attrs: {
                                                              disabled:
                                                                _vm.isDownloading,
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.downloadImage(
                                                                  _vm.selectedImage,
                                                                  "original",
                                                                  {
                                                                    format:
                                                                      _vm
                                                                        .downloadOptions
                                                                        .format,
                                                                    maxSizeKB:
                                                                      _vm
                                                                        .downloadOptions
                                                                        .maxSize,
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "bi bi-download mr-2",
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.isDownloading
                                                                    ? "Preparing download..."
                                                                    : `Download ${_vm.downloadOptions.format.toUpperCase()}`
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.translatedImageUrls,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "translated-image-item",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "image-preview-wrapper position-relative",
                                              },
                                              [
                                                _vm.translatedImageUrls.length >
                                                0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "translated-image-label text-xs text-muted-foreground",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              item.language ||
                                                                `Image ${
                                                                  index + 1
                                                                }`
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.isLoading
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column justify-content-center align-items-center bg-light",
                                                        staticStyle: {
                                                          "min-height": "200px",
                                                          width: "100%",
                                                          "padding-left":
                                                            "16px",
                                                          "padding-right":
                                                            "16px",
                                                          "border-radius":
                                                            "4px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "spinner-border text-primary",
                                                            attrs: {
                                                              role: "status",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sr-only",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Loading..."
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mt-2 text-muted small",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    Translating...\n                  "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : item.error
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column justify-content-center align-items-center bg-light text-danger",
                                                        staticStyle: {
                                                          "min-height": "200px",
                                                          width: "100%",
                                                          "border-radius":
                                                            "4px",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-exclamation-triangle mb-2",
                                                          staticStyle: {
                                                            "font-size": "2rem",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-center px-3",
                                                            class:
                                                              item.errorMessage
                                                                ? "mb-1"
                                                                : "mb-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  item.errorMessage
                                                                    ? "Translation blocked by OpenAI safety filters"
                                                                    : "Translation Failed"
                                                                ) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        item.errorMessage
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mb-2 text-center px-3",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      item.errorMessage
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-sm btn-outline-danger",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.retryTranslation(
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "bi bi-arrow-clockwise mr-1",
                                                            }),
                                                            _vm._v(
                                                              " Retry\n                  "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : item.url
                                                  ? [
                                                      _c("img", {
                                                        staticClass:
                                                          "img img-fluid modal-preview-image",
                                                        attrs: {
                                                          src: item.url,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-actions-container",
                                                          style:
                                                            _vm
                                                              .translatedImageUrls
                                                              .length > 0
                                                              ? { top: "35px" }
                                                              : { top: "10px" },
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "retry-btn",
                                                              attrs: {
                                                                title:
                                                                  "Retry translation",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.retryTranslation(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "bi bi-arrow-clockwise",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "download-btn",
                                                              attrs: {
                                                                title:
                                                                  "Download image",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.toggleDownloadOptions(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "bi bi-download",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.activeDownloadOptionsIndex ===
                                                          index
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-download-dropdown",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex align-items-center mb-3",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "custom-radio mr-3 mb-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .downloadOptions
                                                                                        .format,
                                                                                    expression:
                                                                                      "downloadOptions.format",
                                                                                  },
                                                                                ],
                                                                              attrs:
                                                                                {
                                                                                  type: "radio",
                                                                                  value:
                                                                                    "jpg",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  checked:
                                                                                    _vm._q(
                                                                                      _vm
                                                                                        .downloadOptions
                                                                                        .format,
                                                                                      "jpg"
                                                                                    ),
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$set(
                                                                                      _vm.downloadOptions,
                                                                                      "format",
                                                                                      "jpg"
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span"
                                                                          ),
                                                                          _vm._v(
                                                                            " JPG\n                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "custom-radio mb-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .downloadOptions
                                                                                        .format,
                                                                                    expression:
                                                                                      "downloadOptions.format",
                                                                                  },
                                                                                ],
                                                                              attrs:
                                                                                {
                                                                                  type: "radio",
                                                                                  value:
                                                                                    "png",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  checked:
                                                                                    _vm._q(
                                                                                      _vm
                                                                                        .downloadOptions
                                                                                        .format,
                                                                                      "png"
                                                                                    ),
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$set(
                                                                                      _vm.downloadOptions,
                                                                                      "format",
                                                                                      "png"
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span"
                                                                          ),
                                                                          _vm._v(
                                                                            " PNG\n                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm
                                                                    .downloadOptions
                                                                    .format ===
                                                                  "jpg"
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex align-items-center mb-3",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "download-label mb-0 mr-2",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                          Max size\n                        "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model.number",
                                                                                    value:
                                                                                      _vm
                                                                                        .downloadOptions
                                                                                        .maxSize,
                                                                                    expression:
                                                                                      "downloadOptions.maxSize",
                                                                                    modifiers:
                                                                                      {
                                                                                        number: true,
                                                                                      },
                                                                                  },
                                                                                ],
                                                                              staticClass:
                                                                                "form-control form-control-sm download-size-input",
                                                                              attrs:
                                                                                {
                                                                                  type: "number",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .downloadOptions
                                                                                      .maxSize,
                                                                                },
                                                                              on: {
                                                                                input:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    )
                                                                                      return
                                                                                    _vm.$set(
                                                                                      _vm.downloadOptions,
                                                                                      "maxSize",
                                                                                      _vm._n(
                                                                                        $event
                                                                                          .target
                                                                                          .value
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                blur: function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.$forceUpdate()
                                                                                },
                                                                              },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "download-unit ml-2",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "KB"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn btn-primary w-100",
                                                                      attrs: {
                                                                        disabled:
                                                                          _vm.isDownloading,
                                                                        type: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.downloadImage(
                                                                              item.url,
                                                                              item.language,
                                                                              {
                                                                                format:
                                                                                  _vm
                                                                                    .downloadOptions
                                                                                    .format,
                                                                                maxSizeKB:
                                                                                  _vm
                                                                                    .downloadOptions
                                                                                    .maxSize,
                                                                              }
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "bi bi-download mr-2",
                                                                      }),
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm.isDownloading
                                                                              ? "Preparing download..."
                                                                              : `Download ${_vm.downloadOptions.format.toUpperCase()}`
                                                                          ) +
                                                                          "\n                      "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-removal-footer d-flex flex-column gap-2",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-content-between gap-2",
                                    staticStyle: { padding: "16px 0px" },
                                  },
                                  [
                                    _c("div", { staticClass: "d-flex gap-2" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              _vm.isLoading ||
                                              _vm.isCreatingTemplate ||
                                              _vm.isRemovingBackground ||
                                              !_vm.canTranslate ||
                                              _vm.isLoadingTextBlocks,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleTranslate()
                                            },
                                          },
                                        },
                                        [
                                          _vm.isLoading
                                            ? _c("span", {
                                                staticClass:
                                                  "spinner-border spinner-border-sm",
                                                attrs: {
                                                  role: "status",
                                                  "aria-hidden": "true",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("b-icon", {
                                            attrs: { icon: "translate" },
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.isLoading
                                                  ? "Translating..."
                                                  : "Translate"
                                              ) +
                                              "\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.editedImageUrl
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-secondary",
                                              attrs: {
                                                type: "button",
                                                disabled:
                                                  _vm.isLoading ||
                                                  _vm.isCreatingTemplate ||
                                                  _vm.isRemovingBackground,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemoveBackground()
                                                },
                                              },
                                            },
                                            [
                                              _vm.isRemovingBackground
                                                ? _c("span", {
                                                    staticClass:
                                                      "spinner-border spinner-border-sm",
                                                    attrs: {
                                                      role: "status",
                                                      "aria-hidden": "true",
                                                    },
                                                  })
                                                : _c("i", {
                                                    staticClass: "bi bi-image",
                                                  }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.isRemovingBackground
                                                      ? "Removing..."
                                                      : "Remove Background"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _vm.editedImageUrl
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex gap-2" },
                                          [
                                            _vm.hasMultipleLanguages
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "position-relative",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary",
                                                        attrs: {
                                                          type: "button",
                                                          disabled:
                                                            _vm.isCreatingTemplate ||
                                                            _vm.isDownloadingAllImages ||
                                                            _vm.isAnyImageProcessing(),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.handleDownloadAllOptions.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm.isDownloadingAllImages
                                                          ? _c("span", {
                                                              staticClass:
                                                                "spinner-border spinner-border-sm",
                                                              attrs: {
                                                                role: "status",
                                                                "aria-hidden":
                                                                  "true",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isDownloadingAllImages
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Downloading..."
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !_vm.isDownloadingAllImages
                                                          ? _c("span", [
                                                              _c("i", {
                                                                staticClass:
                                                                  "bi bi-download mr-1",
                                                              }),
                                                              _vm._v(
                                                                " Download All "
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "bi bi-chevron-down ml-1",
                                                              }),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.activeDownloadAllOptions
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "custom-download-dropdown custom-download-dropdown--download-all",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center mb-3",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "custom-radio mr-3 mb-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .downloadOptions
                                                                                  .format,
                                                                              expression:
                                                                                "downloadOptions.format",
                                                                            },
                                                                          ],
                                                                        attrs: {
                                                                          type: "radio",
                                                                          value:
                                                                            "jpg",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            checked:
                                                                              _vm._q(
                                                                                _vm
                                                                                  .downloadOptions
                                                                                  .format,
                                                                                "jpg"
                                                                              ),
                                                                          },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                _vm.downloadOptions,
                                                                                "format",
                                                                                "jpg"
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span"),
                                                                    _vm._v(
                                                                      " JPG\n                      "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "custom-radio mb-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .downloadOptions
                                                                                  .format,
                                                                              expression:
                                                                                "downloadOptions.format",
                                                                            },
                                                                          ],
                                                                        attrs: {
                                                                          type: "radio",
                                                                          value:
                                                                            "png",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            checked:
                                                                              _vm._q(
                                                                                _vm
                                                                                  .downloadOptions
                                                                                  .format,
                                                                                "png"
                                                                              ),
                                                                          },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                _vm.downloadOptions,
                                                                                "format",
                                                                                "png"
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span"),
                                                                    _vm._v(
                                                                      " PNG\n                      "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.downloadOptions
                                                              .format === "jpg"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex align-items-center mb-3",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "download-label mb-0 mr-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Max size"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model.number",
                                                                              value:
                                                                                _vm
                                                                                  .downloadOptions
                                                                                  .maxSize,
                                                                              expression:
                                                                                "downloadOptions.maxSize",
                                                                              modifiers:
                                                                                {
                                                                                  number: true,
                                                                                },
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "form-control form-control-sm download-size-input",
                                                                        attrs: {
                                                                          type: "number",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              _vm
                                                                                .downloadOptions
                                                                                .maxSize,
                                                                          },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              )
                                                                                return
                                                                              _vm.$set(
                                                                                _vm.downloadOptions,
                                                                                "maxSize",
                                                                                _vm._n(
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              )
                                                                            },
                                                                          blur: function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.$forceUpdate()
                                                                          },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "download-unit ml-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "KB"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn-primary w-100",
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.isDownloadingAllImages,
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.downloadAllImagesZip(
                                                                        {
                                                                          format:
                                                                            _vm
                                                                              .downloadOptions
                                                                              .format,
                                                                          maxSizeKB:
                                                                            _vm
                                                                              .downloadOptions
                                                                              .maxSize,
                                                                        }
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "bi bi-download mr-2",
                                                                }),
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      _vm.isDownloadingAllImages
                                                                        ? "Preparing download..."
                                                                        : `Download All ${_vm.downloadOptions.format.toUpperCase()}`
                                                                    ) +
                                                                    "\n                    "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown",
                                              {
                                                attrs: {
                                                  text: "Add to New Template",
                                                  variant: "primary",
                                                  disabled:
                                                    _vm.isCreatingTemplate ||
                                                    _vm.isAnyImageProcessing(),
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddToNewTemplate(
                                                          "original"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Original size\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("b-dropdown-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddToNewTemplate(
                                                          1500,
                                                          1500
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    1500x1500\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddToNewTemplate(
                                                          2000,
                                                          2000
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    2000x2000\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddToNewTemplate(
                                                          2500,
                                                          2500
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    2500x2500\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddToNewTemplate(
                                                          3000,
                                                          3000
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    3000x3000\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("b-dropdown-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleAddToNewTemplate(
                                                          "custom"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Custom...\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            !_vm.hasMultipleLanguages
                                              ? _c(
                                                  "b-dropdown",
                                                  {
                                                    attrs: {
                                                      split: "",
                                                      variant: "primary",
                                                      disabled:
                                                        _vm.isCreatingTemplate,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSave(
                                                          false
                                                        )
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "button-content",
                                                          fn: function () {
                                                            return [
                                                              _vm.isCreatingTemplate
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "spinner-border spinner-border-sm",
                                                                    attrs: {
                                                                      role: "status",
                                                                      "aria-hidden":
                                                                        "true",
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.isCreatingTemplate
                                                                      ? "Creating..."
                                                                      : "Add to Template"
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      343358371
                                                    ),
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-dropdown-item",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isProductImage,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSave(
                                                              true
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.isCreatingTemplate
                                                                ? "Creating..."
                                                                : "Add to template & open Make Editable modal"
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _c(
                    "div",
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link p-0 mb-3",
                          attrs: { type: "button" },
                          on: { click: _vm.handleBackToTranslate },
                        },
                        [
                          _c("i", {
                            staticClass: "bi bi-arrow-left-short mr-1",
                          }),
                          _vm._v(" Back to Translate\n        "),
                        ]
                      ),
                      _vm._v(" "),
                      _c("TranslationSettingsView", {
                        attrs: {
                          mode: "modal",
                          "show-header-description": true,
                        },
                        on: {
                          "settings-changed": _vm.applyTranslationSettings,
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.isLoadingTextBlocks
                ? _c("div", { staticClass: "loading-overlay" }, [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-2 text-white font-weight-bold" },
                      [_vm._v("\n          Detecting text blocks...\n        ")]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }